import { createSlice } from '@reduxjs/toolkit'
import initialState from "./initState"
import { Platform } from "react-native";
import avatar1 from "../assets/images/avatar_mit_background.png"
import { rrulestr } from 'rrule';
import Moment from 'moment';
import { produce } from "immer"
import { saveSettings } from './thunks';

let lut = [];
for (let i = 0; i < 256; i++) {
    lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
}

const guid7 = (pfx) => {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    // let pfx = lut[d0 & 0xff]
    pfx = pfx || lut[d0 & 0xff]
    return pfx + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
        lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
        lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
        lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
}

const collectAvatar = (avatar, media) => {
    if (avatar && typeof avatar == 'string' && !media.avatar.includes(avatar)) {
        media.avatar.push(avatar)
    }
}

const collectMediaAll = (workflow, avatar, media) => {
    if (avatar && typeof avatar == 'string' && !media.avatar.includes(avatar)) {
        media.avatar.push(avatar)
    }
    media.top = media.top.concat(workflow.media)
    workflow.steps.forEach(step => {
        media.other = media.other.concat(step.media)
        if (step.check) {
            step.check.forEach(item => {
                media.other = media.other.concat(item.media)
            })
        }
    })
    return media
}

const decodeWorkflow = (workflowRemote, deleted) => {
    let workflow = {
        owned: true, contact: null, shared: false, locked: false, title: 'Error: ' + workflowRemote.name, text: 'Error parsing this workflow', step: -1, id: workflowRemote.id, workflowId: workflowRemote.id, media: [], steps: []
    }
    try {
        workflow = JSON.parse(workflowRemote.workflowData)
        workflow.workflowId = workflowRemote.workflowId || workflowRemote.id
        workflow.contact = workflowRemote.published ? workflowRemote.published.image?.id || avatar1 : workflowRemote.contact?.id
        workflow.publisher = workflowRemote.published
        workflow.owned = workflow.contact == null && workflowRemote.published == null
        workflow.locked = false
        workflow.shared = workflowRemote.published != null
        workflow.public = workflowRemote.published != null
        workflow.changed = new Date((workflowRemote.modifiedAt || workflowRemote.createdAt) + 'Z').getTime()
        workflow.deleted = workflowRemote.deleted
    } catch (error) {
        console.log(workflowRemote, error)
        workflow.text = '' + error
    }
    return workflow
}

const pushSync = (syncs, entry, replace) => {
    let mode = 'ADD'
    if (replace) {
        const len = syncs.len
        syncs = syncs.filter(sync => sync.usage != entry.usage || sync.data.entrypoint != entry.data.entrypoint || (entry.data.taskid && sync.data?.taskid != entry.data.taskid))
        if (syncs.len < len) {
            mode = 'REP'
        }
    }
    entry.id = guid7()
    entry.time = new Date().toLocaleString()
    entry.retry = 0
    syncs.push(entry)
    console.ina('SYNC ' + mode, entry)
    return syncs
}

function loadingEnd(state, endpoint, response, begTime) {
    const loading = state.remote.loading[endpoint]
    if (!loading) {
        // unknown request ?
        console.log('SYNC OFFLINE', Date.now() - begTime, endpoint)
    } else {
        if (loading?.begTime > begTime) {
            // old request
            console.log('SKIP', Date.now() - begTime, endpoint)
            return state
        }
        // console.log('XXX', loading)
        // loading.duration = Date.now() - loading.begTime
    }
    console.log('RESPONSE', Object.keys(response || {}))
    // let responseFiltered = {}
    // for (let key in response) {
    //     if (key.startsWith('_') || ['headers', 'blob', 'arrayBuffer', 'text', 'formData'].includes(key)) {
    //         responseFiltered[key] = '?'
    //     } else {
    //         responseFiltered[key] = response[key]
    //     }
    // }
    state.remote.active = false
}

const mainSlice = createSlice({
    name: 'main',
    initialState,
    reducers: {
        addPlannedNotification(state, action){
            const {plan} = action.payload;
            state.plannedNotifications = [...state.plannedNotifications, plan]
        },
        deletePlannedNotification(state, action){
            const {plan} = action.payload;
            state.plannedNotifications = state.plannedNotifications.filter(item => item.id !== plan.id)
        },
        addToBePlannedNotification(state, action){
            const {plan} = action.payload;
            state.notificationsToBePlanned = [...state.notificationsToBePlanned, plan]
        },
        deleteToBePlannedNotification(state, action){
            const {plan} = action.payload;
            state.notificationsToBePlanned = state.notificationsToBePlanned.filter(item => item.id !== plan.id)
        },
        requestModal(state, action) {
            if (!('modal' in state.temp)) {
                state.temp.modal = {};
            }

            state.temp.modal[action.payload?.type] = {
                opener: 'request',
                opened: Date.now(),
                option: action.payload?.option
            };

            // ---
            console.debug('[Modal]', 'request', action.payload?.type);
            // ---
        },
        deleteModal(state, action) {
            if (state.temp?.modal && (action.payload?.type in state.temp.modal)) {
                delete state.temp.modal[action.payload?.type];

                // ---
                console.debug('[Modal]', 'closed', action.payload?.type);
                // ---
            }
        },
        updateModal(state, action) {
            if (state.temp?.modal && (action.payload?.type in state.temp.modal)) {
                state.temp.modal[action.payload?.type].option = {
                    ...(state.temp.modal[action.payload?.type].option ?? {}),
                    ...action.payload.option
                };

                // ---
                console.debug('[Modal]', 'update', action.payload?.type, action.payload);
                // ---
            }
        },
        // console.log('STATE', action, JSON.stringify(state, ["version", "changed", "users", "images", "remote", "temp", "user", "server", "workflows", "tasks", "planned", "contacts", "settings", "deleted", "published", "commit", "notify"]))
        changeState(state, action) {
            const { changes } = action.payload
            let newState = { ...state, ...changes }
            console.log('CHANGE_STATE', changes)
            return newState
        },
        cloudToken(state, action){
            const {token} = action.payload
            if(state.cloudMessaging.token !== token){
                let newSync = pushSync([...state.server.sync], { usage: 'SEND_CLOUD_TOKEN', data: { endpoint: `/cloud-messaging/${token}`, method: 'POST' } }, true)
                console.log("Setting token...", token)
                return {
                    ...state,
                    cloudMessaging: {
                        token: token
                    },
                    server: { ...state.server, sync: newSync }
                }
            }
            return state
        },
        deleteCloudToken(state, action) {
            let token = state.cloudMessaging.token;
            let newSync = pushSync([...state.server.sync], { usage: 'DELETE_CLOUD_TOKEN', data: { endpoint: `/cloud-messaging/${token}`, method: 'DELETE' } }, true)
            return {
                ...state,
                cloudMessaging: {
                    token: ''
                },
                server: { ...state.server, sync: newSync }
            }
        },
        wsConnect(state, action) {
            const { uuid, reconnect } = action.payload
            return {
                ...state,
                server: { ...state.server, ws: { id: uuid, connected: false, connecting: true, error: undefined, retries: reconnect ? state.server.ws.retries - 1 : 3 } }
            }
        },
        wsState(state, action) {
            const { connected, ws } = action.payload
            return {
                ...state,
                server: { ...state.server, ws: { ...state.server.ws, connected: connected, connecting: false, error: undefined, retries: connected ? 3 : state.server.ws.retries } }
            }
        },
        wsError(state, action) {
            const { error } = action.payload
            return {
                ...state,
                server: { ...state.server, ws: { ...state.server.ws, error: error } }
            }
        },
        wsSend(state, action) {
            return state
        },
        wsChat(state, action) {
            const { chatMsg } = action.payload
            const updatedChat = [...state.server.chat, chatMsg]
            console.ina("MainSlice Chat: ", updatedChat)
            //const msg = JSON.parse(chatMsg)
            // const c = chat.findIndex(c => c.id == msg.id)
            // if (c > -1) {
            //     chat[c] = msg
            // } else {
            //     chat.push(msg)
            // }
            return {
                ...state,
                server: { ...state.server, chat: updatedChat }
            }
        },
        wsChatClear(state, action) {
            return {
                ...state,
                server: {
                    ...state.server,
                    chat: []
                }
            }
        },
        logout(state, action) {
            const { clean } = action.payload
            if (clean) {
                console.log("LOGOUT")
                if (state.users[state.user.id]) {
                    let users = { ...state.users }
                    delete users[state.user.id]
                    return {
                        ...initialState,
                        users: users,
                    }
                }
                return initialState
            }
            if (state.user.id) {
                console.log("SWITCH USER")
                // save userData for later use
                let userData = {}
                Object.keys(state.init).forEach(key => userData[key] = state[key])
                return {
                    ...initialState,
                    users: { ...state.users, [state.user.id]: JSON.stringify(userData) },
                }
            }
            console.log("INITSTATE")
            return initialState
        },
        reset(state, action) {
            console.log("RESET")
            return initialState
        },
        setOnline(state, action) {
            const { status } = action.payload
            return {
                ...state,
                server: { ...state.server, online: status }
            }
        },
        migrate(state, action) {
            const { version } = action.payload
            console.log("MIGRATE", state.version, version)
            let newState = { ...state }
            // check currently used version
            if (['1.0.0', '1.0.1', '1.0.5', '1.0.6', '1.0.7', '1.0.8', '1.0.9'].includes(state.version)) {
                newState.init = initialState.init
                newState.users = { ...state.users }
                newState.images = { seq: 0, act: 0, err: 0, list: [], load: {} }
                newState.icons = { ...state.icons, infos: [70, 71, 72, 73], helps: [74, 75, 76, 77] }
                newState.planned = { plans: [] }
                newState.contacts = { requests: [], active: [], channels: [] }
                newState.settings.speechEnabled = false
                newState.server.api = '/api'
                console.log('adjusted v1/v1+ state to v2 state')
            }
            if (['1.9.2'].includes(state.version)) {
                newState.icons = { ...state.icons, helps: [74, 75, 76, 77] }
            }
            if (['1.9.3'].includes(state.version)) {
                newState.settings.showTOU = false
                newState.settings.showDPA = false
                newState.legal.tou_de = { version: initialState.legal.tou_de.version, html: initialState.legal.tou_de.html }
                newState.legal.dpa_de = { version: initialState.legal.dpa_de.version, html: initialState.legal.dpa_de.html }
                delete (newState.legal.dsgvo_de)
                delete (newState.settings.showAGB)
                delete (newState.settings.showDS)
                console.log('show new dpa, tou versions')
            }
            if (['2.0.8'].includes(state.version)) {
                newState.workflows = { ...state.workflows, ...initialState.init.workflows }
                delete newState.workflows[2]
                newState.icons = { ...initialState.icons }
            }
            if (['2.1.0'].includes(state.version)) {
                newState.settings = { ...state.settings, changed: [] }
                delete newState.tasks.planned
            }
            if (['2.0.9', '2.1.0', '2.1.1', '2.1.2', '2.1.3', '2.1.4', '2.1.5'].includes(state.version)) {
                newState.icons = { ...initialState.icons }
                newState.workflows = { ...state.workflows, ...initialState.init.workflows }
                newState.legal = { ...initialState.legal }
                console.log('refresh icons and actual dpa, tou versions', newState.legal.tou_de.version, newState.legal.dpa_de.version)
            }
            if (['2.1.6', '3.0.0', '3.0.1'].includes(state.version)) {
                newState.icons = { ...initialState.icons }
                newState.workflows = { ...state.workflows, ...initialState.init.workflows }
                console.log('refresh icons and default workflows')
            }
            if (['3.0.2'].includes(state.version)) {
                newState.icons = { ...initialState.icons }
                newState.workflows = produce(state.workflows, draftState => {
                    delete draftState[0]
                    delete draftState[1]
                })
                console.log('refresh icons and remove default workflows')
            }
            if(['3.2.1'].includes(state.version)) {
                newState.cloudMessaging = {
                    token: ''
                }
            }
            if (['3.2.2'].includes(state.version)) {
                newState.icons = { ...initialState.icons }
                console.log('refresh icons')
            }
            if (['3.6.3'].includes(state.version)) {
                newState.ai = { ...initialState.ai }
                console.log('refresh ai prompts')
                newState.icons = { ...initialState.icons }
                console.log('refresh icons')
            }
            newState.version = version
            return newState
        },
        demoLogin(state, action) {
            return {
                ...state,
                user: { isSignedIn: true, id: '00000000-0000-0000-0000-000000000001', name: 'Demo', preferredName: 'Demo', mail: 'demo@ina.coach', demo: true, avatar: avatar1, updated: Date.now(), isAdmin: false },
                server: { ...state.server, online: false }
            }
        },
        count(state, action) {
            const { cnt } = action.payload
            return {
                ...state,
                cnt: cnt + 1
            }
        },
        imageLoad(state, action) {
            const { uri, status } = action.payload
            let newState
            if (status < 0) {
                newState = {
                    ...state,
                    remote: { ...state.remote, active: true },
                    images: {
                        ...state.images,
                        seq: state.images.seq + 1,
                        act: state.images.act + 1,
                        load: { ...state.images.load, [uri]: { state: status, seq: state.images.seq, begTime: Date.now() } }
                    }
                }
            } else {
                if (!state.images.load[uri]) {
                    newState = { ...state }
                } else {
                    newState = {
                        ...state,
                        remote: { ...state.remote, active: state.images.act - 1 > 0 },
                        images: {
                            ...state.images,
                            seq: state.images.seq,
                            act: state.images.act - 1,
                            err: state.images.err + status == 200 ? 0 : 1,
                            load: { ...state.images.load, [uri]: { ...state.images.load[uri], state: status, duration: Date.now() - state.images.load[uri].begTime } }
                        }
                    }
                }
                console.ina('SYNC IMG', uri, newState.images.load[uri])
            }
            Object.keys(newState.images.load).forEach(id => {
                // Detect stopped load based on a 10 minutes wait time
                if (newState.images.load[id].status == -1 && Date.now() - newState.images.load[id].begTime > 10 * 60000) {
                    newState.images.act--
                    newState.images.load[id].status = 998
                    console.ina('IMG KILL', newState.images.load[id])
                }
            })
            return newState
        },
        setBackend(state, action) {
            let { url } = action.payload
            switch (url) {
                case 'test':
                    url = 'https://test.app.ina.coach'
                    break
                case 'prod':
                    url = 'https://app.ina.coach'
                    break
                default:
                    if (url.match(/^[0-9]{1,3}$/)) {
                        url = 'http://192.168.178.' + url + ':3000'
                    }
                    if (url.match(/^-[0-9]{1,3}$/)) {
                        url = 'http://192.168.178.' + url.substring(1) + ':8082'
                    }
            }
            console.log('URL', url, action.payload)
            return {
                ...initialState,
                server: { ...initialState.server, url: url }
            }
        },
        show(state, action) {
            const { level } = action.payload
            let show = state
            if (level) {
                if (level == 'logs') {
                    show = initialState.temp.logs
                } else {
                    let levels = level.split('.')
                    levels.forEach(level => show = show[level])
                    console.log(level, JSON.stringify(show, null, 2))
                }
            } else {
                show = Object.keys(state)
                console.log(show)
            }
            if (show) {
                show = JSON.stringify(show, null, 2)
                return { ...state, temp: { ...state.temp, msg: { level: 'info', text: show, i18n: false } } }
            } else {
                return { ...state, temp: { ...state.temp, msg: { level: 'info', text: 'Unknown state: ' + level, i18n: false } } }
            }
            return state
        },
        setDebug(state, action) {
            const { debug } = action.payload
            return { ...state, debug: debug }
        },
        updateNotify(state, action) {
            const { notify } = action.payload
            const notifyNew = { ...state.notify, ...notify };
            console.log('NOTIFY', notifyNew)
            return { ...state, notify: notifyNew }
        },
        storeTemp(state, action) {
            const { temp } = action.payload
            return { ...state, temp: { ...state.temp, ...temp } }
        },
        storePerf(state, action) {
            const { data } = action.payload
            return produce(state, draftState => {
                draftState.temp.perf = data
                if (draftState.temp.perfs) {
                    draftState.temp.perfs.push(data)
                } else {
                    draftState.temp.perfs = [data]
                }
            })
            // return { ...state, temp: { ...state.temp, perf: data, perfs: state.temp.perfs ? [...state.temp.perfs, data] : [data] } }
        },
        setMessage(state, action) {
            const { msg, level, text, options } = action.payload
            return { ...state, temp: { ...state.temp, msg: msg } }
        },
        clearMessage(state, action) {
            return { ...state, temp: { ...state.temp, msg: null } }
        },
        changeSettings(state, action) {
            const { settings } = action.payload
            const settingsNew = { ...state.settings, ...settings }
            console.log('CHANGE_SETTING', settingsNew)
            return {
                ...state,
                settings: settingsNew
            }
        },
        updateSettings(state, action) {
            const { settings } = action.payload
            const settingsNew = { ...state.settings, ...settings }
            console.log('UPDATE_SETTINGS', settingsNew, state.notify)
            let newSync = pushSync([...state.server.sync], { usage: 'SYNC_SETTINGS', data: { endpoint: '/user', json: { settings: JSON.stringify(settingsNew) }, method: 'PUT' } }, true)
            return {
                ...state,
                settings: settingsNew,
                notify: { ...state.notify, tasklist: settingsNew.changed.length > 0 },
                server: { ...state.server, sync: newSync }
            }
        },
        acceptTOU(state, action) {
            const { showTOU } = action.payload
            const settings = { ...state.settings, showTOU: showTOU }
            let newSync = pushSync([...state.server.sync], { usage: 'SYNC_SETTINGS', data: { endpoint: '/user', json: { settings: JSON.stringify(settings), touVersion: state.legal.tou_de.version }, method: 'PUT' } }, true)
            return { ...state, settings: settings, server: { ...state.server, sync: newSync } }
        },
        acceptDPA(state, action) {
            const { showDPA } = action.payload
            const settings = { ...state.settings, showDPA: showDPA }
            let newSync = pushSync([...state.server.sync], { usage: 'SYNC_SETTINGS', data: { endpoint: '/user', json: { settings: JSON.stringify(settings), dpaVersion: state.legal.dpa_de.version }, method: 'PUT' } }, true)
            return { ...state, settings: settings, server: { ...state.server, sync: newSync } }
        },
        taskStart(state, action) {
            const { task } = action.payload
            let newSteps = [...state.workflows[task.id].steps]
            newSteps.forEach((step, s) => {
                // clean all checklists
                let newStep = { ...step }
                if (newStep.type == 1) {
                    newStep.check = newStep.check.map(item => {
                        return { ...item, done: false }
                    })
                }
                // stop all timers
                if (newStep.type == 2) {
                    newStep.timerBeg = undefined
                    newStep.timerPause = undefined
                    newStep.timerFinished = undefined
                }
                newSteps[s] = newStep
            })
            let newState = {
                ...state,
                tasks: { ...state.tasks, active: state.tasks.active.indexOf(task.id) < 0 ? [...state.tasks.active, task.id] : state.tasks.active },
                workflows: {
                    ...state.workflows,
                    [task.id]: {
                        ...state.workflows[task.id],
                        step: state.workflows[task.id].step == -1 ? 0 : state.workflows[task.id].step,
                        steps: newSteps
                    }
                }
            }
            // console.log("<", newState.tasks.active)
            return newState
        },
        taskSteps(state, action) {
            const { taskid, steps, step } = action.payload
            let newState = {
                ...state,
                workflows: { ...state.workflows, [taskid]: { ...state.workflows[taskid], steps: steps, step: step != null ? step : state.workflows[taskid].step } }
            }
            return newState
        },
        taskPause(state, action) {
            const { taskid, stepIdx, timerBeg, timerPause } = action.payload
            let newSteps = [...state.workflows[taskid].steps]
            newSteps[stepIdx] = { ...newSteps[stepIdx], timerBeg: timerBeg, timerPause: timerPause }
            console.log('PAUSE', action, newSteps[stepIdx])
            let newState = {
                ...state,
                tasks: { ...state.tasks, high: [...state.tasks.high] },
                workflows: { ...state.workflows, [taskid]: { ...state.workflows[taskid], steps: newSteps } }
            }
            return newState
        },
        taskTimer(state, action) {
            const { taskid, stepIdx, start, done, isSimulator = false } = action.payload
            let newSteps = [...state.workflows[taskid].steps]
            const newStep = { ...newSteps[stepIdx], timerBeg: start ? Date.now() : undefined, timerPause: undefined, timerFinished: !start ? Date.now() : undefined }
            newSteps[stepIdx] = newStep
            const active = newSteps.some(step => step.timer != null && step.timerBeg != undefined)
            console.log('TIMER', active, state.tasks.high.includes(taskid), newSteps[stepIdx])
            console.log('Task timer', taskid, stepIdx, start, done)
            let newState = {
                ...state,
                tasks: { ...state.tasks, high: active ? (state.tasks.high.includes(taskid) ? [...state.tasks.high] : [...state.tasks.high, taskid]) : state.tasks.high.filter(taskid => taskid != taskid) },
                workflows: { ...state.workflows, [taskid]: { ...state.workflows[taskid], steps: newSteps } }
            }
            if (done) {
                newState.temp = { ...state.temp, msg: { level: 'info', text: 'message.timerDone', options: { taskid: taskid, task: state.workflows[taskid].title, step: newSteps[stepIdx].title }, i18n: true, isSimulator } }
            }
            return newState
        },
        taskDone(state, action) {
            const { taskid, abort } = action.payload
            let newSteps = [...state.workflows[taskid].steps]
            newSteps.forEach((step, s) => {
                // clean all checklists
                let newStep = { ...step }
                if (newStep.type == 1) {
                    newStep.check = newStep.check.map(item => {
                        return { ...item, done: false }
                    })
                }
                // stop all timers
                if (newStep.type == 2) {
                    newStep.timerBeg = undefined
                    newStep.timerPause = undefined
                    newStep.timerFinished = undefined
                }
                newSteps[s] = newStep
            })
            const newTask = { ...state.workflows[taskid], step: -1, steps: newSteps, done: abort ? undefined : Date.now() }
            const newPlans = [...state.planned.plans]
            let newSync = [...state.server.sync]
            if (!abort) {
                const date = Moment().startOf('day').toISOString()
                const dayBeg = new Date(Moment(date).subtract(1, 'ms'));
                const dayEnd = new Date(Moment(date).endOf('day'));
                const planned = state.planned.plans.filter(plan => plan.workflowId == newTask.workflowId
                    && (undefined == plan.doneAt || !Moment().isSame(Moment(plan.doneAt + 'Z'), 'date'))
                    && rrulestr(plan.schedule).between(dayBeg, dayEnd).length > 0).sort((a, b) => a.startAt > b.startAt)
                const allDay = planned.filter(plan => Moment().startOf('day').isSame(Moment(plan.startAt + 'Z')))
                const done = allDay.length > 1 ? allDay : planned.length > 0 ? [planned[0]] : []
                done.forEach(plan => {
                    newPlans[state.planned.plans.indexOf(plan)] = { ...plan, "doneAt": Moment().format('YYYY-MM-DDTHH:mm:SS') }
                    console.log('PLAN', newPlans[state.planned.plans.indexOf(plan)])
                    newSync = pushSync(newSync, {
                        usage: 'SYNC_PLAN', data: {
                            endpoint: '/planned/' + plan.id, json:
                            {
                                "doneAt": new Date().toJSON(),
                            },
                            method: 'PUT'
                        }
                    }, false)
                })
            }
            return {
                ...state,
                tasks: {
                    high: state.tasks.high.filter(id => id != taskid),
                    active: state.tasks.active.filter(id => id != taskid),
                },
                workflows: { ...state.workflows, [taskid]: newTask },
                server: { ...state.server, sync: newSync },
                planned: { ...state.planned, plans: newPlans }
            }
        },
        taskSettings(state, action) {
            const { taskid, settings } = action.payload
            const task = { ...state.workflows[taskid], settings: { ...state.workflows[taskid].settings, ...settings } }
            let newSync = pushSync([...state.server.sync], {
                usage: 'SYNC_WF_UPDATE', data: {
                    endpoint: '/workflow/' + task.workflowId,
                    json: {
                        name: task.title,
                        description: task.text,
                        workflowData: JSON.stringify(task)
                    },
                    method: 'PUT',
                    mediaAdd: [],
                    taskid: task.id,
                    workflowId: task.workflowId
                }
            }, true)
            return {
                ...state,
                workflows: { ...state.workflows, [task.id]: task },
                server: { ...state.server, sync: newSync }
            }
        },
        taskImport(state, action) {
            const { task } = action.payload
            let newSync = pushSync([...state.server.sync], {
                usage: 'SYNC_WF_IMPORT', data: {
                    endpoint: '/workflow/' + task.workflowId,
                    json: {
                        name: task.title,
                        description: task.text,
                        workflowData: JSON.stringify(task)
                    },
                    method: 'PUT',
                    taskid: task.id,
                    workflowId: task.workflowId
                }
            }, true)
            let newState = {
                ...state,
                workflows: { ...state.workflows, [task.id]: task },
                server: { ...state.server, sync: newSync }
            }
            newState.settings = { ...state.settings, changed: state.settings.changed ? [...state.settings.changed, task.id] : [task.id] }
            console.log('IMPORT', newState.settings)
            newState.notify = { ...state.notify, tasklist: true }
            newState.server.sync = pushSync(newState.server.sync, { usage: 'SYNC_SETTINGS', data: { endpoint: '/user', json: { settings: JSON.stringify(newState.settings) }, method: 'PUT' } }, true)
            return newState
        },
        taskDelete(state, action) {
            const { taskid } = action.payload
            const workflow = state.workflows[taskid]
            if (workflow?.simulatorPreview === true || taskid.length == 1) {
                delete state.workflows[taskid]
                state.tasks.high = state.tasks.high.filter(id => id != taskid)
                state.tasks.active = state.tasks.active.filter(id => id != taskid)
                return
            }
            if (!workflow) {
                return
            }
            const deleted = { ...workflow, deleted: Moment().toISOString() };
            console.log('TASK', deleted, [...state.deleted, deleted])
            // TODO: with trashcan this is of no use => find better way to cleanup unused images!!!
            // let media = collectMedia(deleted)
            // deleteImagesAsync(media)
            let newSync = pushSync([...state.server.sync], { usage: 'SYNC_WF_DELETE', data: { endpoint: '/workflow/' + deleted.workflowId, json: null, method: 'DELETE', taskid: taskid } }, true)
            let newState = {
                ...state,
                tasks: {
                    high: state.tasks.high.filter(taskid => taskid != taskid),
                    active: state.tasks.active.filter(taskid => taskid != taskid)
                },
                workflows: { ...state.workflows, [taskid]: deleted },
                server: { ...state.server, sync: newSync },
                deleted: [...state.deleted, deleted]
            }
            if (state.settings.changed.includes(taskid)) {
                newState.settings = { ...state.settings, changed: state.settings.changed.filter(taskid => taskid != taskid) }
                newState.notify = { ...state.notify, tasklist: newState.settings.changed.length > 0 }
                newState.server.sync = pushSync(newState.server.sync, { usage: 'SYNC_SETTINGS', data: { endpoint: '/user', json: { settings: JSON.stringify(newState.settings) }, method: 'PUT' } }, true)
            }
            return newState
        },
        updateAvatar(state, action) {
            const { avatar } = action.payload
            return { ...state, user: { ...state.user, avatar: avatar, updated: Date.now() } }
        },
        addSync(state, action) {
            const { usage, data } = action.payload
            let newSync = pushSync([...state.server.sync], { usage: usage, data: data }, false)
            return { ...state, server: { ...state.server, sync: newSync } }
        },
        startSync(state, action) {
            console.log('SYNC START', state.server.sync.length)
            return {
                ...state,
                remote: { ...state.remote, syncActive: true }
            }
        },
        doneSync(state, action) {
            const { done } = action.payload
            // all executed sync requests are removed
            console.log('SYNC DONE', done.length, state.server.sync.length)
            let newSync = state.server.sync.filter(sync => !done.includes(sync.id))
            // unlock workflows
            // let workflows = {}
            // state.server.sync
            //     .filter(sync => done.includes(sync.id) && sync.data.taskid && state.workflows[sync.data.taskid])
            //     .forEach(sync => workflows[sync.data.taskid] = { ...state.workflows[sync.data.taskid], locked: false })
            return {
                ...state,
                server: { ...state.server, sync: newSync },
                remote: { ...state.remote, syncActive: false },
                // workflows: { ...state.workflows, ...workflows }
            }
        },
        startRequest(state, action) {
            const { usage, endpoint, data, begTime } = action.payload
            console.ina('INIT', usage, endpoint, new Date(begTime).toLocaleString())
            return produce(state, draftState => {
                draftState.remote.loading[endpoint] = { usage: usage, data: data, begTime: begTime }
                draftState.remote.active = true
                // if (usage == 'ONLINE') {
                //     draftState.server.online = false
                // }
            })
        },
        receiveJson(state, action) {
            const { usage, endpoint, json, response, begTime } = action.payload
            loadingEnd(state, endpoint, response, begTime)
            switch (usage) {
                case 'LOGIN':
                case 'ONLINE':
                    console.log('STATE', Object.keys(state))
                    // console.log('STATE', JSON.stringify(state))
                    // console.log(usage, state.user, json)
                    console.log(action)
                    console.log('USERS', Object.keys(state.users))
                    if (state.users[json.id]) {
                        // re-establish saved user data
                        console.log('ACTIVATE', json.id)
                        state.user = JSON.parse(state.users[json.id])
                    }
                    state.user = { ...json, isSignedIn: true, name: json.preferredName, avatar: json.userImage ? json.id : avatar1, updated: Date.now(), isAdmin: json.role ? json.role == 'Admin' : json.roleSet.indexOf('Admin') > -1 }
                    console.log('CHECK', state.legal.dpa_de.version, json.dpaVersion, initialState.legal.dpa_de.version)
                    const isSynced = state.server.sync.some(sync => sync.usage == 'SYNC_SETTINGS')
                    const settings = isSynced ? {} : JSON.parse(json.settings)
                    state.settings = {
                        ...state.settings,
                        ...settings,
                        showTOU: state.legal.tou_de.version != json.touVersion,
                        showDPA: state.legal.dpa_de.version != json.dpaVersion
                    }
                    // console.log(usage, state.user, state.settings)
                    state.images = { ...state.images, act: 0 }
                    state.commit = initialState.commit
                case 'TOKEN_LOGIN':
                    // TODO: fix for SDK51 issue with FileSystem.downloadAsync and FileSystem.uploadAsync on Android -- this is available in mobile apps but not in browsers
                    if (response?.headers?.['set-cookie']) {
                        state.server.jwt = response?.headers['set-cookie'].replace(/[^=]+=/, '').replace(/;.*/, '')
                        console.log('JWT', state.server.jwt)
                    }
                    state.server.online = true
                    state.server.login = Date.now()
                    if ((!state.server.refreshed || Date.now() - state.server.refreshed > 15 * 60 * 1000)) {
                        state.server.sync = pushSync(state.server.sync, { usage: 'SYNC_CONTACTS', data: { endpoint: '/contact/user', json: null, method: 'GET' } }, true)
                    }
                    break
                case 'UPDATE_USER':
                case 'SYNC_UPDATE_USER':
                    // console.log(usage, state.user, json)
                    state.user = { ...state.user, ...json, name: json.preferredName }
                    // console.log(usage, state.user)
                    break
                case 'SETTINGS':
                    state.settings = { ...state.settings, ...JSON.parse(json.settings) }
                    console.log('UPDATE_SETTINGS', state.settings)
                case 'SYNC_SETTINGS':
                    // console.log(usage, json)
                    break
                case 'DELETE_USER':
                    state = initialState
                    break
                case 'SYNC_CONTACTS':
                case 'SYNC_PLAN':
                case 'GET_CONTACTS_INLINE':
                case 'GET_WORKFLOWS_INLINE':
                case 'ACCEPT_REQUEST_INLINE':
                case 'DECLINE_REQUEST_INLINE':
                case 'DELETE_REQUEST_INLINE':
                case 'REQUEST_CONTACT_INLINE':
                case 'CREATE_CONTACT_INLINE':
                case 'UPDATE_CONTACT_INLINE':
                case 'DELETE_CONTACT_INLINE':
                case 'UPDATE_CHANNEL_INLINE':
                case 'DELETE_CHANNEL_INLINE':
                case 'UPDATE_IMAGE_INLINE':
                case 'SHARE_WORKFLOW_INLINE':
                case 'GET_PLAN_OTHER':
                case 'CREATE_PLAN_INLINE':
                case 'UPDATE_PLAN_INLINE':
                case 'DELETE_PLAN_INLINE':
                case 'PROCESS_QRCODE_INLINE':
                case 'SHARE_PUBLIC_INLINE':
                case 'DELETE_PUBLIC_INLINE':
                case 'DELETE_TASKS_INLINE':
                case 'UNDELETE_TASKS_INLINE':
                case 'STUDIO_DONATE':
                case 'STUDIO_UNDONATE':
                case 'STUDIO_TAKE':
                case 'STUDIO_COPY_WF':
                case 'STUDIO_DELETE_WF':
                case 'PLANNER_REQUEST':
                case 'CANCEL_PLANNER_REQUEST':
                case 'ACCEPT_PLANNER_REQUEST':
                case 'REJECT_PLANNER_REQUEST':
                    if (json) {
                        const begTime = Date.now()
                        console.log('REFRESH', Object.keys(json).map(key => {
                            if (Array.isArray(json[key])) {
                                return { key: key, size: json[key]?.length }
                            } else {
                                if (key == 'planned' && json.planned.planned) {
                                    return { key: key, size: json.planned.planned.length, result: json.planned.result }
                                } else {
                                    return { key: key, result: json[key] }
                                }
                            }
                        }))
                        // add all previously changed tasks (app and studio)
                        let changed = state.settings.changed ? [...state.settings.changed] : []
                        let hasChanges = false
                        if (json.workflows) {
                            let replaceWorkflows = {}
                            let wfMap = {}
                            let media = { top: [], other: [], avatar: [] }
                            let notify = state.notify ? { ...state.notify, header: false, contacts: false, tasklist: false } : { header: false, contacts: false, tasklist: false }

                            const keepIds = Object.keys(state.workflows).filter(id => state.workflows[id].simulatorPreview === true || id.length == 1 || state.workflows[id].workflowId == undefined || state.workflows[id].step > -1)
                            console.log('KEEP', keepIds)
                            keepIds.forEach(id => {
                                replaceWorkflows[id] = { ...state.workflows[id] }
                                replaceWorkflows[id].owned = replaceWorkflows[id].contact == null
                                replaceWorkflows[id].locked = false
                                replaceWorkflows[id].shared = false
                                if (replaceWorkflows[id].workflowId) {
                                    wfMap[replaceWorkflows[id].workflowId] = id
                                }
                            })
                            // extract workflows and skip started or deleted ones
                            let studioMap = {}
                            json.workflows = json.workflows.map(workflowR => {
                                let workflow = decodeWorkflow(workflowR)
                                const id = workflow.id
                                if (!keepIds.includes(id) && !state.workflows[id]?.deleted) {
                                    replaceWorkflows[id] = workflow
                                    wfMap[replaceWorkflows[id].workflowId] = id
                                    collectMediaAll(workflow, workflow.contact || state.user.avatar, media)
                                    // add previously unknown tasks
                                    if (!changed.includes(id) && !state.workflows[id]) {
                                        changed.push(id)
                                        hasChanges = true
                                    }
                                }
                                // the workflow has an existing studio id
                                if (workflow?.studio?.id) {
                                    studioMap[workflow.studio.id] = id
                                }
                                return workflow
                            })
                            let studioIds = []
                            if (json.studio) {
                                studioIds = json.studio.map(studio => studio.id)
                                state.studio = json.studio.map(studio => {
                                    const workflow = JSON.parse(studio.workflowData)
                                    // the exported workflow id does not exist, but there is a workflow referring to this studio id
                                    if (!replaceWorkflows[workflow.workflowId] && studioMap[workflow.id]) {
                                        console.log('FIX STUDIO', workflow.workflowId, studioMap[workflow.id], studio.name)
                                        workflow.workflowId = studioMap[workflow.id]
                                    }
                                    return { ...{ step: -1, media: [], steps: [], owned: true, settings: {} }, ...workflow, id: studio.id, title: studio.name, text: studio.description, changed: new Date((studio.modifiedAt || studio.createdAt) + 'Z').getTime() }
                                })
                                if (state.studio) {
                                    // add previously unknown studio tasks
                                    const studioNew = studioIds.filter(id => !changed.includes(id) && !state.studio.find(workflowStudio => id == workflowStudio.id))
                                    if (studioNew.length > 0) {
                                        changed = changed.concat(studioNew)
                                        hasChanges = true
                                    }
                                }
                            }

                            // console.log('WMAP', wfMap)
                            let tasks2shares = {}
                            // collect workflow to contact / channel info and convert remote workflow ids to local workflow ids
                            json.active.forEach(contact => contact.workflows = contact.workflows.map(workflow => {
                                const id = wfMap[workflow.id]
                                // all replaceWorkflows have a wfMap entry, if there is none the workflow is no longer existing
                                if (id) {
                                    if (!tasks2shares[id]) {
                                        tasks2shares[id] = { contacts: [contact.id], channels: [] }
                                    } else {
                                        tasks2shares[id].contacts.push(contact.id)
                                    }
                                    replaceWorkflows[id].shared = true
                                }
                                collectAvatar(contact?.contactImage?.id || contact.toUser.id, media)
                                return id
                            }))
                            json.channels.forEach(channel => {
                                channel.contacts = channel.contacts.map(contact => contact.id)
                                channel.workflows = channel.workflows.map(workflow => {
                                    // all replaceWorkflows have a wfMap entry, if there is none the workflow is no longer existing
                                    const id = wfMap[workflow.id]
                                    if (id) {
                                        if (!tasks2shares[id]) {
                                            tasks2shares[id] = { contacts: [], channels: [channel.id] }
                                        } else {
                                            tasks2shares[id].channels.push(channel.id)
                                        }
                                        replaceWorkflows[id].shared = true
                                    }
                                    collectAvatar(channel?.channelImage?.id, media)
                                    return id
                                })
                            })
                            // console.log('MEDIAS', json.medias)
                            if (json.market) {
                                state.market = json.market.map(task => {
                                    const data = JSON.parse(task.data)
                                    const stats = JSON.parse(task.stats)
                                    return { ...task, data: data, stats: stats }
                                })
                            }
                            state.contacts = { ...json, tasks2shares: tasks2shares }
                            state.workflows = replaceWorkflows
                            state.wfMap = wfMap
                            state.images = {
                                ...state.images,
                                avatar: media.avatar,
                                list: media.avatar
                                    .filter(imgId => {
                                        if (null == state.images.load[imgId]) {
                                            return true
                                        }
                                        const id = imgId.replace(/\..*/, '')
                                        if (json.medias && json.medias[id]) {
                                            const createdAt = new Date(json.medias[id].createdAt + 'Z');
                                            console.log('REFRESH', imgId, createdAt, new Date(state.images.load[imgId].begTime), state.images.load[imgId].begTime - createdAt.getTime() < 0)
                                            return state.images.load[imgId].begTime - createdAt.getTime() < 0
                                        } else {
                                            return Date.now() - state.images.load[imgId].begTime > 60 * 60000
                                        }
                                    })
                                    .concat(media.top
                                        .concat(media.other)
                                        .filter(imgId => !imgId.startsWith('file:///') && null == state.images.load[imgId]))
                            }
                            // remove unknown and deleted tasks
                            changed = changed.filter(taskid => {
                                if ((state.workflows[taskid] && !state.workflows[taskid].deleted) || studioIds.includes(taskid)) {
                                    return true
                                } else {
                                    hasChanges = true
                                    return false
                                }
                            })
                            if (changed.filter(taskid => !studioIds.includes(taskid)).length > 0) {
                                console.log('MARKNEW', state.settings?.changed, state.settings?.changed, state.workflows[state.settings?.changed])
                                notify.tasklist = true
                            }
                            if (state.contacts.requests.some(request => request.fromUser.id != state.user.id)) {
                                notify.header = true
                                notify.contacts = true
                            }
                            state.notify = notify
                            // first time usage done
                            if (Platform.OS !== 'web' && state.images.act == 0 && state.images.list.length > 0) {
                                if ((!state.images.refreshed || usage == 'GET_WORKFLOWS_INLINE' || Date.now() - state.images.refreshed > 30 * 60000)) {
                                    state.server.sync = pushSync(state.server.sync, { usage: 'SYNC_IMAGES_LIST', data: { batch: 20, endpoint: '/workflow/media/', method: 'POST' } }, true)
                                    state.images.refreshed = Date.now()
                                }
                            }
                            // console.log('IMAGES', JSON.stringify(state.images, null, 2))
                            console.log('IMAGES', `avatars: ${media.avatar.length}, top: ${media.top.length}, other: ${media.other.length}, loaded: ${Object.keys(state.images.load).length}, load/reload: ${state.images.list.length}, refeshed: ${new Date(state.images.refreshed)}`)
                            // console.log('CONTACTS', state.contacts.active)
                            // console.log('CHANNELS', state.contacts.channels)
                            // console.log('CONTACT_WF', state.contacts.workflows.map(w => {return {title: w.title, contact: w.contact}}))
                        }
                        // prevent change tracking for first time usage
                        if (hasChanges && state.changed) {
                            state.settings = { ...state.settings, changed: changed }
                            console.log('CHANGED', state.settings)
                            state.server.sync = pushSync(state.server.sync, { usage: 'SYNC_SETTINGS', data: { endpoint: '/user', json: { settings: JSON.stringify(state.settings) }, method: 'PUT' } }, true)
                        }
                        state.changed = true
                        if (json.deleted) {
                            state.deleted = json.deleted.map(workflowR => decodeWorkflow(workflowR))
                        }
                        if (json.published) {
                            state.published = json.published
                        }
                        if (json.planned.planned) {
                            // console.log('PPLANNED', json.planned.planned)
                            // existing backend multiResponse
                            state.planned = {
                                ...state.planned,
                                plans: json.planned.planned
                            }
                        } else {
                            // console.log('PLANNED', json.planned, json.result)
                            // existing backend userPlanned response
                            if (usage == 'GET_PLAN_OTHER' || null != json.result && null != json.result.createdFor && json.result.createdFor.id != state.user.id) {
                                state.planned = {
                                    ...state.planned,
                                    other: json.planned
                                }
                            } else {
                                state.planned = {
                                    ...state.planned,
                                    plans: json.planned // TODO: fast but wrong! .filter(plan => plan.taskid )
                                }
                            }
                        }
                        // console.log('PUBLISHED', state.published)
                        // console.log('PLANNED', state.planned)
                        // console.log('RESULT', state.contacts.result)
                        //console.log("Workflows: ", state.workflows)
                        // console.log("Planned: ", state.planned)
                        // console.log("Contacts: ", state.contacts.active)

                        //let str = JSON.stringify(state.workflows, null, 2)
                        //console.log(str)

                        state.server.refreshed = Date.now()
                        console.log('Refreshed at ' + new Date(state.server.refreshed) + ' in ' + (state.server.refreshed - begTime) + 'ms')
                    }
                    break
                case 'IMAGE_AVATAR':
                case 'SYNC_IMAGE_AVATAR':
                    console.log('XXX', json)
                    state.user = { ...state.user, avatar: json.createdBy.id, updated: Date.now() }
                    break
                case 'IMAGE_PUBLIC':
                case 'SYNC_IMAGE_PUBLIC':
                    state.user = { ...state.user, publicImage: { id: json.id } }
                    break
                case 'WF_CREATE':
                case 'SYNC_WF_CREATE':
                    // workflow has been created and got a new id (and will be updated - see SYNR_WF_UPDATE below)
                    break
                case 'WF_UPDATE':
                case 'SYNC_WF_UPDATE':
                    {
                        console.log(usage, json)
                        let workflow = decodeWorkflow(json)
                        workflow.workflowId = json.id
                        workflow.locked = false
                        state.workflows = { ...state.workflows, [workflow.id]: workflow }
                    }
                    break
                case 'SYNR_WF_IMAGE':
                case 'IMAGE_SCREENSHOT':
                case 'SYNC_IMAGE_SCREENSHOT':
                    break
                case 'SYNC_WF_DELETE':
                    {
                        // workflow needs to be deleted locally
                        state.workflows = { ...state.workflows }
                        let workflow = decodeWorkflow(json)
                        delete state.workflows[workflow.id]
                        console.log('SYND', json)
                    }
                    break
                case 'TOKEN':
                    state.server.token = json
                    console.log("TOKEN", json)
                    break
                case 'STUDIO_CREATE_WORKFLOW':
                case 'STUDIO_AUTOSAVE':
                case 'STUDIO_GET_USER_WF':
                case 'STUDIO_GET_MEDIA':
                case 'STUDIO_UPLOAD_MEDIA':
                case 'STUDIO_DELETE_MEDIA':
                case 'STUDIO_MEDIA_EXPORT':
                    console.log("STUDIO RESPONSE:", response)
                    break
                default:
                    console.log('ignored:', action)
            }
            console.ina('DONE', usage, endpoint, state.remote.loading[endpoint]?.duration + 'ms')
        },
        transmitError(state, action) {
            const { usage, endpoint, error, message, begTime } = action.payload
            loadingEnd(state, endpoint, null, begTime)
            console.ina('FAIL', usage, endpoint, state.remote.loading[endpoint]?.duration + 'ms', error, message)
            if (usage == 'LOGIN' || usage == 'ONLINE' || message.includes("Network request failed")) {
                if (error == 401) {
                    state.temp = { ...state.temp, msg: { level: 'error', text: 'message.nologin', i18n: true } }
                }
                state.server.online = false
            } else {
                if (usage.startsWith('SYNC_')) {
                    state.server.sync = [...state.server.sync]
                    const sync = state.server.sync.find(sync => sync.usage == usage && sync.data.endpoint == endpoint)
                    if (sync) {
                        sync.status = error
                        console.log('SYNC ERR', sync)
                    }
                }
                if (error >= 500) {
                    let msg;
                    switch (error) {
                        case 997:
                            msg = { level: 'error', text: 'message.uploadError', options: { error: message }, i18n: true }
                            break;
                        case 998:
                            msg = { level: 'error', text: 'message.imageError', options: { image: message }, i18n: true }
                            break;
                        case 999:
                            msg = { level: 'error', text: 'message.internalError', options: { error: message }, i18n: true }
                            break;
                        default:
                            msg = { level: 'error', text: 'message.serverError', i18n: true }
                    }
                    if (msg) {
                        state.temp = { ...state.temp, msg: msg }
                    }
                } else {
                    // Do NOT show any errors for _INLINE, ONLINE or SYNC_WF_DELETE' requests
                    if (!usage.endsWith('_INLINE') && usage != 'ONLINE' && usage != 'SYNC_WF_DELETE') {
                        if (error == 401) {
                            state.temp = { ...state.temp, msg: { level: 'error', text: 'message.notAuth', i18n: true } }
                            state.user = { ...state.user, isSignedIn: false, updated: Date.now() }
                        }
                        state.temp = { ...state.temp, msg: { level: 'error', text: (message ? message : usage + ': ' + state.server.api + endpoint) + ' (' + error + ')', i18n: false } }
                    }
                }
            }
        },
    },
    extraReducers: (builder) => {
        // Use `extraReducers` to handle actions that were generated
        // _outside_ of the slice, such as thunks or in other slices
        builder
            .addCase(saveSettings.pending, (state, action) => {
                console.log('XXX', 'loading', action)
            })
            // Pass the generated action creators to `.addCase()`
            .addCase(saveSettings.fulfilled, (state, action) => {
                console.log('XXX', 'fulfilled', action)
                if (action.payload == null) {
                    // request changed into SYNC request => update settings locally
                    state.settings = { ...state.settings, ...action.meta.arg }
                }
            })
            .addCase(saveSettings.rejected, (state, action) => {
                console.log('XXX', 'rejected', action)
            })
    },

})

export const { addPlannedNotification, deletePlannedNotification, addToBePlannedNotification, deleteToBePlannedNotification, deleteCloudToken, cloudToken, requestModal, deleteModal, updateModal, changeState, reset, migrate, setOnline, wsConnect, wsState, wsError, wsSend, wsChat, demoLogin, setDebug, updateNotify, storeTemp, storePerf, setMessage, clearMessage, count, imageLoad, setBackend, logout, updateAvatar, show, taskStart, taskTimer, taskPause, taskImport, taskSteps, taskPin, taskSettings, taskDone, taskDelete, addSync, startSync, doneSync, changeSettings, updateSettings, acceptTOU, acceptDPA, startRequest, receiveJson, transmitError , wsChatClear} = mainSlice.actions

export default mainSlice.reducer;
